// eslint-disable-next-line no-redeclare,no-unused-vars
function keyName(key) {
    if (!key) return;
    key.replace(/[^a-z0-9]/gi, '');
    key = key.slice(0, 1).toLowerCase() + key.slice(1);
    return key;
}

//# sourceMappingURL=index.eae8db46.js.map
